import { Confirmation } from 'components/ui'
import { FC } from 'react'

interface Props {
  name?: string
  onConfirm?: () => any
  onDismiss?: () => any
}

const DeleteConfirmation: FC<Props> = ({ name, onConfirm, onDismiss }) => {
  return (
    <Confirmation
      danger
      title={`Delete "${name}"?`}
      message={
        <>
          Are you sure you want to delete this?
          <br />
          This action is irreversible.
        </>
      }
      showBypassTip={true}
      onConfirm={onConfirm}
      onDismiss={onDismiss}
    />
  )
}

export default DeleteConfirmation
